<template>
  <div class="search-container">
    <div class="tile is-parent">
      <article class="tile is-child box">
        <div class="block">
          <div class="control is-horizontal">
            <div class="control">
              <router-link class="button is-info width-1" target="_blank" :to="{ name: 'manage'}" style="margin-right: 20px;">公众号管理</router-link>
              <router-link  class="button is-success" target="_blank" :to="{name: 'add'}" style="margin-right: 20px;">添加公众号</router-link>
              <input class="input-text" type="text" placeholder="搜索文章" v-model='searchKey'>

            </div>
          </div>
          <div class="control is-horizontal">
            <div class="control is-horizontal">
              <label class="label inline-block r-top">最近更新</label>
              <el-select v-model="currentCategoryId" filterable clearable placeholder="请选择">
                <el-option
                  v-for="(item,index) in categoryListL"
                  :key="item.categoryId"
                  :label="item.categoryText"
                  :value="item.categoryId">
                </el-option>
              </el-select>
              <button class="button is-primary margin-left" @click="searchClick">搜索</button>
            </div>
          </div>
        </div>
      </article>
    </div>
    <div class="list-wrap">
      <div v-if="count > 0" class="clearfix">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child box">
          <waterfall :column-width="380">
            <div class="waterfall-container">
              <div v-for="(item,key) in list" class="card-item waterfall-item">
              <div class="item-container">
                <a class="avatar-wrap clearfix" :href="'/adminv/#/subscriptions/detail?accountNumber='+item.accountNumber+'&categoryId=[]'">
                  <img class="avatar fleft" :src="item.avatar">
                  <div class="info fleft">
                    <p class="name">{{item.accountName}}</p>
                    <p class="time">最近更新{{item.dateTime}}</p>
                  </div>
                </a>
                <account-card :item-messagedata="item.messageList" :item-categorylist="item.categories" @subscribe-click="subscribeClick"></account-card>
                <div class="category-wrap" @click='onShowModel(key,item)'>
                  <span v-for="(value,k) in item.categories">
                    <span class="category" v-if="value.categoryName">{{value.categoryName}}</span>
                  </span>
                </div>
              </div>
              </div>
            </div>
          </waterfall>
          <category-modal ref="categoryModalRef" :item="modal.item" :item-categorylist='modal.itemCategorylist' @update-category-event="updateCategoryEvent"></category-modal>
        </article>
      </div>
      <div v-if="count > 0" class="clearfix">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
    </div>
    <thread-base-modal ref="threadBaseModalRef" :message-title="messageTitle" @do-save-tread-event="doSaveTreadEvent"></thread-base-modal>
  </div>
</template>
<script type="text/babel">
  import waterfall from 'COMMON/waterfall/waterfall.vue'
  import AccountCard from '../common/accountCard/accountCard';
  import ThreadBaseModal from '../common/threadBaseModal/threadBaseModal';
  import CategoryModal from '../common/categoryModal/categoryModal';
  import {formatImageByQiniu} from 'UTILS/_url'
  import {formatDate} from 'UTILS/date'
  import {mapActions} from 'vuex';

  export default {
    components: {
      waterfall,AccountCard,ThreadBaseModal,CategoryModal
    },
    data(){
      return {
        visiblePreview:false,
        previewData:{},//预览所需参数
        accountData:{},//抓取的文章数据
        threadBaseInfo:{},//帖子的基本信息
        selectedCategory: {},
        list:[],
        categoryListL:[],
        currentCategoryId:[],
        searchKey: '',
        currentPage:1,
        pageSize:20,
        count:1,
        currentIndex: 0,
        messageTitle:"",//当前要抓取的文章名称
        modal:{
          item: {},
          name:"",
          itemCategorylist: {}
        }
      }
    },
    mounted(){
      this.getUpdateList({})
      this.getCategoryList({})
    },
    events:{
      //预览
      PREVIEW_EVENT(data){
        this.visiblePreview = true;
      }
    },
    methods: {
      ...mapActions([
        'commitWaterfallUpdate'
      ]),
      /*
      * 内容抓取点击
      * */
      subscribeClick(data){
        this.messageTitle = data.title;
        this.accountData = data;
        this.$refs.threadBaseModalRef && this.$refs.threadBaseModalRef.showModal();
      },
      //分类更新
      updateCategoryEvent(data){
        this.list[this.currentIndex].categories = data
      },
      handleCurrentChange(value){
        if(this.currentPage !== value){
          this.currentPage = value;
          this.getUpdateList();
        }
      },
      searchClick(){
        this.getUpdateList()
      },
      getCategoryList(){
        HttpRequest.post('/admin.php?method=wechat.getAccountCategory', true).then((response) => {
            this.categoryListL = _.toArray(response.data)
          _.each(this.categoryListL,(item,index)=>{
            item.categoryText = item.categoryName+' • '+item.count;
          })
        })
      },
      onShowModel(key, item) {
        this.currentIndex = key
        this.modal.item = {accountNumber: item.accountNumber}
        this.modal.itemCategorylist = item.categories;
        this.$refs.categoryModalRef && this.$refs.categoryModalRef.showModal()
      },
      getUpdateList() {
        let params = {
          keyword: this.searchKey,
          accountNumber:"",
          page:this.currentPage,
          pageSize:this.pageSize
        }
        if (this.currentCategoryId) {
          params.categoryIds = [this.currentCategoryId]
        }
        HttpRequest.get('/admin.php?method=wechat.getUpdateList', params, true).then((response) => {
          this.list = _.toArray(response.data.list);
          //这里的count会有问题,是所有messageList的总和
          this.count = response.data.count;
          _.each(this.list,(item,index)=>{
            item.avatar = formatImageByQiniu(item.avatar,60,60);
            item.dateTime = formatDate(item.dateTime,'yyyy-MM-dd hh:mm:ss');
            _.each(item.messageList,(list,k)=>{
              list.accountNumber = item.accountNumber;
            })
          })
          this.commitWaterfallUpdate(true);
        })
      },
      //抓取保存
      doSaveTreadEvent(data){
        this.threadBaseInfo = data;
        let params = Object.assign(this.threadBaseInfo,{
          accountNumber:this.accountData.accountNumber,
          fileId:this.accountData.fileId,
          msgId:this.accountData.msgId
        });
        HttpRequest.post("/admin.php?method=wechat.doSaveAsThread", params, true).then((response) => {
          if (response.data.result == true) {
            if(!confirm('帖子已经生成,ID'+response.data.threadId+',是否跳转至帖子详情?')){
              return false;
            }

            let link = document.createElement("a");
            link.href =  "/adminv/#!/threadEdit?threadId="+response.data.threadId
            link.target = '_blank'
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }else{
            alert("生成失败!")
          }
        }, (response) => {

        });
      }
    }
  }
</script>
<style lang="less">
.item-container{
  padding: 20px;
  width: 380px;
  display: inline-block;
  border-radius: 5px;
  border: 2px solid #efefef;
  margin-bottom:20px;
  .avatar-wrap{
    display: block;
    margin-bottom: 10px;
    .avatar{
      width: 50px;
      height: 50px;
      border-radius: 60px;
    }
    .info{
      margin-left: 20px;
      .name{
        font-size: 18px;
        color: #333;
        font-weight: 500;
        width: 150px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        display: inline-block;
      }
      .time{
        font-size: 14px;
        color: #666;
      }
    }
  }
  .category-wrap{
    width: 100%;
    max-height: 80px;
    overflow: auto;
    margin-top: 10px;
    cursor: pointer;
    .category{
      background: #eaeaea;
      padding: 5px 10px;
      color: #333;
      margin: 0 10px 10px 0;
      display: inline-block;
    }
  }
}
.input-text{
  margin-right: 10px;
  width: 220px;
}
</style>
